// extracted by mini-css-extract-plugin
export var root = "H_vf";
export var wrapper = "H_sZ";
export var image = "H_vg d_w d_y d_W";
export var imageWithHeight = "H_vh";
export var crop = "H_vj";
export var round = "H_vk";
export var fixedHeight = "H_vl";